import { createContext } from "react";


export type RegisterStep = "email" | "personalInfo" | "phone";
export type EmailSubstep = "input" | "otp";
export type PersonalInfoSubstep = "input" | "password";
export type PhoneSubstep = "input" | "otp" | "consent";

export interface RegisterContextType {
  step: RegisterStep;
  setStep: (s: RegisterStep) => void;
  emailSubstep: EmailSubstep;
  setEmailSubstep: (s: EmailSubstep) => void;
  personalInfoSubstep: PersonalInfoSubstep;
  setPersonalInfoSubstep: (s: PersonalInfoSubstep) => void;
  phoneSubstep: PhoneSubstep;
  setPhoneSubstep: (s: PhoneSubstep) => void;

  email: string;
  setEmail: (v: string) => void;
  otp: string;
  setOtp: (v: string) => void;
  personalInfo: RegisterPersonalInfo;
  setPersonalInfo: (v: RegisterPersonalInfo) => void;
  password: string;
  setPassword: (v: string) => void;
  confirmPassword: string;
  setConfirmPassword: (v: string) => void;
  otpId: string;
  setOtpId: (v: string) => void;
  otpFactorId: string;
  setOtpFactorId: (v: string) => void;
  phone: string;
  setPhone: (v: string) => void;
  phoneFactorId: string;
  setPhoneFactorId: (v: string) => void;
  phoneConsent: boolean;
  setPhoneConsent: (v: boolean) => void;
  userUUID: string;
  setUserUUID: (v: string) => void;
  goNext: () => void;
  goBack: () => void;
}

export interface RegisterPersonalInfo {
  lastName: string;
  loanNumber: string;
  ssn: string;
}

export const RegisterContext = createContext<RegisterContextType>({} as RegisterContextType);
